import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Illustration from '../../Illustration';

import avatar from '@material-ui/core/colors/grey';

import {
  CardList,
  CardListItem,
  ColumnItem,
} from '../../core';

import {
  selectVendorsList,
} from '../../../store/selectors';

const styles = theme => ({
  avatar: {
    margin: '10px',
    color: '#fff',
    backgroundColor: avatar[500],
  },
});

const VendorCards = ({ classes, vendors, handleSelect }) => {
  return (
    <CardList handleSelect={handleSelect}>
      {vendors.length > 0 &&
        vendors.map((vendor, i) => {
          return (
            <CardListItem key={i} item={vendor} handleSelect={handleSelect}>
              <ColumnItem>
                <Avatar className={classes.avatar}>
                  V
                </Avatar>
              </ColumnItem>
              <ColumnItem>
                <Typography noWrap variant="subheading">
                  {vendor.name}
                </Typography>
              </ColumnItem>
            </CardListItem>
          );
        })
      }
      {vendors.length === 0 &&
        <Illustration
          title="Hmm, no Vendors..."
          imgKey="experts_amber"
          explainerText="While vendors aren’t required… if you want to know where all the money goes this will help."
          addItemText="Let’s get them entered by clicking the “Floating Action Button” at top right."        />
      }
    </CardList>
  );
};

const mapStateToProps = (state) => ({
  vendors: selectVendorsList(state),
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(VendorCards);



// WEBPACK FOOTER //
// ./src/components/admin/Vendors/VendorCards.jsx